class AttendanceMinutesCalculationUtils {
  /**
   * Calculates balanced regular minutes following the next formula:
   * balancedRegularMinutes = workedMinutes - paidBreaksMinutes - extraHoursMinutesFromBalance
   * This keeps regular hours tied to the physical worked time while subtracting
   * any paid breaks and the extra hours already accounted for in balance.
   *
   * @param workedMinutes - Physical worked minutes from backend
   * @param paidBreaksMinutes - Paid break minutes from backend
   * @param extraHoursMinutesFromBalance - Extra hours from balance calculation
   * @returns Balanced regular minutes
   */
  static calculateBalancedRegularMinutes({
    workedMinutes,
    paidBreaksMinutes,
    extraHoursMinutesFromBalance,
  }: {
    workedMinutes: number
    paidBreaksMinutes: number
    extraHoursMinutesFromBalance: number
  }): number {
    const balanced = workedMinutes - paidBreaksMinutes - extraHoursMinutesFromBalance
    return Math.max(balanced, 0)
  }
}

export default AttendanceMinutesCalculationUtils
